// THIS FILE IS GENERATED BY scripts/build-help-index.ts. DO NOT EDIT.
import type { HelpArticleMeta } from './types';

export const HELP_ARTICLES: HelpArticleMeta[] = [
  {
    "slug": "dashboard-layout",
    "title": "Understanding the Dashboard",
    "summary": "The platform rail, the site workspace column and its switcher, the breadcrumb, and the Cmd+K palette — every way to move around the platform.",
    "tier": "getting-started",
    "category": "orientation",
    "tags": [
      "navigation",
      "sidebar",
      "rail",
      "breadcrumb",
      "command-palette",
      "layout"
    ],
    "relatedArticles": [
      "keyboard-shortcuts-quick",
      "first-site",
      "platform-overview"
    ],
    "lastVerified": "2026-05-30",
    "adminOnly": false
  },
  {
    "slug": "platform-overview",
    "title": "Platform Overview",
    "summary": "A two-minute tour of the AEO Content Platform — how a topic becomes a published article without leaving the dashboard.",
    "tier": "getting-started",
    "category": "orientation",
    "tags": [
      "overview",
      "pipeline",
      "brainstorm",
      "publish",
      "dashboard"
    ],
    "relatedArticles": [
      "first-site",
      "understanding-the-pipeline",
      "first-article-end-to-end"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "understanding-the-pipeline",
    "title": "How the AI Pipeline Works",
    "summary": "The autonomous write-review-iterate loop that turns an approved brief into a draft, and what to do when it doesn't converge.",
    "tier": "getting-started",
    "category": "pipeline",
    "tags": [
      "pipeline",
      "writer",
      "reviewer",
      "iteration",
      "review-score",
      "autonomous"
    ],
    "relatedArticles": [
      "platform-overview",
      "first-article-end-to-end"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "keyboard-shortcuts-quick",
    "title": "Essential Keyboard Shortcuts",
    "summary": "The shortcuts that matter on day one — open help, switch sites, preview, save, navigate the editor.",
    "tier": "getting-started",
    "category": "reference",
    "tags": [
      "shortcuts",
      "keyboard",
      "keys",
      "productivity",
      "hotkeys"
    ],
    "relatedArticles": [
      "dashboard-layout",
      "platform-overview"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "first-site",
    "title": "Creating Your First Site",
    "summary": "The five-step wizard that turns a one-sentence description into a provisioned Cloudflare Pages site with AI-generated context and prompts.",
    "tier": "getting-started",
    "category": "setup",
    "tags": [
      "site",
      "wizard",
      "setup",
      "scaffolding",
      "context",
      "packs"
    ],
    "relatedArticles": [
      "dashboard-layout",
      "platform-overview",
      "keyboard-shortcuts-quick"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "first-article-end-to-end",
    "title": "Your First Article: End to End",
    "summary": "From a single topic to a live article in eight steps — brainstorm, approve, pipeline, draft, edit, annotate, revise, publish.",
    "tier": "getting-started",
    "category": "workflow",
    "tags": [
      "workflow",
      "brainstorm",
      "pipeline",
      "draft",
      "publish",
      "end-to-end"
    ],
    "relatedArticles": [
      "platform-overview",
      "understanding-the-pipeline",
      "dashboard-layout"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "alerts",
    "title": "Managing Alerts",
    "summary": "The Alerts feed surfaces pipeline failures, stuck runs, deploy errors, and traffic anomalies, grouped by severity. Filter by type and site, mark read, and dismiss the read ones in bulk.",
    "tier": "features",
    "category": "alerts",
    "tags": [
      "alerts",
      "notifications",
      "pipeline",
      "deploy",
      "severity",
      "dismiss",
      "quota"
    ],
    "relatedArticles": [
      "pipeline",
      "canceling-pipeline",
      "search-filter-sort"
    ],
    "lastVerified": "2026-07-01",
    "adminOnly": false
  },
  {
    "slug": "analytics",
    "title": "Analytics Dashboard",
    "summary": "The Analytics page pulls Google Search Console data into metric cards, a per-article table, and AEO signals. Data lands 2-7 days after publish and refreshes from a daily cron.",
    "tier": "features",
    "category": "analytics",
    "tags": [
      "analytics",
      "gsc",
      "clicks",
      "impressions",
      "ctr",
      "aeo"
    ],
    "relatedArticles": [
      "publishing",
      "site-hub",
      "export"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "authority-sources",
    "title": "Authority Sources",
    "summary": "Authority sources are the trusted domains the interlinker cites. Manage them per site, ask AI to suggest 10-20 based on your context, and bulk-add the ones you trust — de-duplicated against existing rows.",
    "tier": "features",
    "category": "authority",
    "tags": [
      "authority",
      "sources",
      "citations",
      "interlink",
      "suggest",
      "trust"
    ],
    "relatedArticles": [
      "authority-citations",
      "interlinks",
      "site-management"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "brainstorm-suggestions",
    "title": "Dynamic Topic Suggestions",
    "summary": "The Brainstorm page shows a row of AI-generated topic chips tuned to your site. Click one to populate the topic input; hit Refresh to regenerate. Suggestions are per-site and cached for 24 hours.",
    "tier": "features",
    "category": "brainstorm",
    "tags": [
      "brainstorm",
      "suggestions",
      "chips",
      "topics",
      "ai",
      "cache"
    ],
    "relatedArticles": [
      "brainstorm",
      "approving-briefs",
      "understanding-the-pipeline"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "regulatory-disclaimers",
    "title": "Disclaimers and Compliance",
    "summary": "Per-site regulatory framing decides which disclaimers attach to published articles and how conservatively the writer phrases claims. The table below maps disclaimer types to when they appear.",
    "tier": "features",
    "category": "compliance",
    "tags": [
      "disclaimers",
      "compliance",
      "regulatory",
      "medical",
      "framing",
      "claims"
    ],
    "relatedArticles": [
      "factual-flags",
      "authority-sources",
      "prompts-overview"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "component-packs",
    "title": "Component Packs",
    "summary": "Toggle the medical, finance, technology, and food packs per site to control which bracket shorthands the editor offers. Core is always on; disabling a pack with in-use shorthand warns you first.",
    "tier": "features",
    "category": "components",
    "tags": [
      "components",
      "packs",
      "shorthand",
      "medical",
      "finance",
      "vertical"
    ],
    "relatedArticles": [
      "shorthand-components",
      "component-reference",
      "site-management"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "managing-site-pages",
    "title": "Managing site pages",
    "summary": "Create, edit, AI-draft, publish, and reorder standalone pages (About, Privacy, Terms, and arbitrary pages) from the Pages tab — shipped through the same git pipeline articles use.",
    "tier": "features",
    "category": "content",
    "tags": [
      "pages",
      "about",
      "privacy",
      "terms",
      "cms",
      "navigation",
      "publish"
    ],
    "relatedArticles": [
      "component-reference",
      "archiving-deleting"
    ],
    "lastVerified": "2026-06-11",
    "adminOnly": false
  },
  {
    "slug": "export",
    "title": "Exporting Data",
    "summary": "Export published-article metrics as CSV from Articles and Analytics, brainstorm history as CSV, and a whole site's content as a ZIP from the site hub. Files download straight to your machine.",
    "tier": "features",
    "category": "data",
    "tags": [
      "export",
      "csv",
      "zip",
      "download",
      "articles",
      "backup"
    ],
    "relatedArticles": [
      "analytics",
      "site-hub",
      "backups"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "domain-setup",
    "title": "Domain and DNS Setup",
    "summary": "Point a custom domain at your site by adding it, creating the CNAME record, verifying, and waiting for SSL. The Domains tab polls and surfaces the exact record to copy.",
    "tier": "features",
    "category": "domains",
    "tags": [
      "domain",
      "dns",
      "cname",
      "ssl",
      "cloudflare",
      "verify"
    ],
    "relatedArticles": [
      "site-management",
      "settings-api-keys",
      "site-hub"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": true
  },
  {
    "slug": "annotations",
    "title": "Annotating Articles",
    "summary": "Leave structured notes on text, components, illustrations, sections, or the whole document. Annotations drive the AI revision flow and never touch your published content.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "annotations",
      "notes",
      "revise",
      "sidebar",
      "anchor-types",
      "redline"
    ],
    "relatedArticles": [
      "revisions",
      "unified-editor",
      "factual-flags"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "authority-citations",
    "title": "Authority Citations",
    "summary": "The reviewer matches claims to your site's authority sources and underlines them. Toggle citations on, then skip or replace each suggested source.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "authority",
      "citations",
      "sources",
      "decorations",
      "skip",
      "replace"
    ],
    "relatedArticles": [
      "authority-sources",
      "interlinks",
      "factual-flags"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "component-reference",
    "title": "Component Properties Reference",
    "summary": "A quick lookup of the nine core bracket components, what each one is for, and which content pack contributes the rest.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "components",
      "reference",
      "shorthand",
      "props",
      "quickanswer",
      "faq",
      "table"
    ],
    "relatedArticles": [
      "shorthand-components",
      "shorthand-syntax",
      "unified-editor",
      "images"
    ],
    "lastVerified": "2026-07-01",
    "adminOnly": false
  },
  {
    "slug": "factual-flags",
    "title": "Factual Flag Review",
    "summary": "The AI reviewer marks unsupported claims in amber. Acknowledge each one — verified, softened, removed, other, or disputed — before the article can publish.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "factual",
      "flags",
      "review",
      "claims",
      "acknowledge",
      "dispute",
      "publish-gate"
    ],
    "relatedArticles": [
      "unified-editor",
      "revisions",
      "authority-citations"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "focus-mode",
    "title": "Focus Mode",
    "summary": "Focus mode hides every annotation and overlay to leave just the prose, for distraction-free reading and line editing.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "focus",
      "mode",
      "distraction-free",
      "prose",
      "reading"
    ],
    "relatedArticles": [
      "visibility-toggles",
      "unified-editor",
      "annotations"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "illustrations",
    "title": "Inline Illustrations",
    "summary": "Generate, regenerate, download, and remove AI-drawn SVG illustrations directly inside the editor — they live as body-level blocks, not metadata.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "illustrations",
      "svg",
      "claude",
      "generate",
      "regenerate",
      "illustration"
    ],
    "relatedArticles": [
      "shorthand-components",
      "unified-editor",
      "component-reference"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "images",
    "title": "Uploading Images",
    "summary": "Drop photos, screenshots, diagrams, and graphics straight into an article with the [Image] block — the backend optimizes each upload, builds responsive variants, and commits them to the site at publish.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "images",
      "upload",
      "photo",
      "screenshot",
      "image",
      "media",
      "drag-and-drop",
      "paste",
      "alt-text"
    ],
    "relatedArticles": [
      "illustrations",
      "shorthand-components",
      "component-reference",
      "shorthand-syntax",
      "unified-editor",
      "publishing"
    ],
    "lastVerified": "2026-07-01",
    "adminOnly": false
  },
  {
    "slug": "interlinks",
    "title": "Internal and External Links",
    "summary": "Attach internal and external links to anchor text using the interlink popover — links are decorations stored as metadata, applied to the first occurrence at publish time.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "interlinks",
      "links",
      "internal",
      "external",
      "decorations",
      "anchor"
    ],
    "relatedArticles": [
      "unified-editor",
      "authority-citations",
      "factual-flags"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "preview-modal",
    "title": "Previewing Your Article",
    "summary": "Open a fullscreen, device-framed preview with the full site chrome. Switch widths, zoom, and jump via a mini table of contents — all without leaving the editor.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "preview",
      "modal",
      "device",
      "zoom",
      "toc",
      "chrome",
      "fullscreen"
    ],
    "relatedArticles": [
      "unified-editor",
      "publishing",
      "illustrations"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "revisions",
    "title": "AI-Powered Revisions",
    "summary": "Compile your annotations into one writer request, review the diff, and accept — accepting swaps body_md and resolves the bundled annotations in one move.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "revisions",
      "revise",
      "ai",
      "diff",
      "accept",
      "annotations",
      "re-review"
    ],
    "relatedArticles": [
      "annotations",
      "factual-flags",
      "unified-editor"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "shorthand-components",
    "title": "Working with Components",
    "summary": "Insert rich content blocks — FAQs, quick answers, comparison tables, and more — using bracket shorthand, the toolbar, or the autocomplete that fires when you type an open bracket.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "shorthand",
      "components",
      "autocomplete",
      "toolbar",
      "brackets",
      "cards"
    ],
    "relatedArticles": [
      "component-reference",
      "unified-editor",
      "illustrations"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "unified-editor",
    "title": "The Unified Inline Editor",
    "summary": "Edit articles with live component previews, inline illustrations, interlink decorations, factual flags, and annotation tools — all in a single scrollable surface.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "editor",
      "tiptap",
      "shorthand",
      "inline",
      "components",
      "annotations",
      "decorations"
    ],
    "relatedArticles": [
      "shorthand-components",
      "annotations",
      "preview-modal"
    ],
    "lastVerified": "2026-07-01",
    "adminOnly": false
  },
  {
    "slug": "visibility-toggles",
    "title": "Annotation Visibility Toggles",
    "summary": "The bar above the editor toggles five overlay layers — illustrations, links, flags, citations, and annotations — so you can read clean prose or every signal at once.",
    "tier": "features",
    "category": "editing",
    "tags": [
      "visibility",
      "toggles",
      "layers",
      "overlays",
      "editor",
      "bar"
    ],
    "relatedArticles": [
      "unified-editor",
      "focus-mode",
      "annotations"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "multi-site-navigation",
    "title": "Multi-Site Navigation",
    "summary": "Switch sites from the workspace switcher or with Cmd+K from anywhere, and read the rail vs workspace split to know which scope a page belongs to.",
    "tier": "features",
    "category": "navigation",
    "tags": [
      "navigation",
      "rail",
      "cmd-k",
      "sidebar",
      "switcher",
      "multi-site"
    ],
    "relatedArticles": [
      "site-management",
      "dashboard-layout",
      "search-filter-sort"
    ],
    "lastVerified": "2026-05-30",
    "adminOnly": false
  },
  {
    "slug": "search-filter-sort",
    "title": "Finding Content",
    "summary": "Every list page carries a debounced search box plus status and type filters, and the URL holds your query and filters so a refresh or a shared link keeps the view.",
    "tier": "features",
    "category": "navigation",
    "tags": [
      "search",
      "filter",
      "sort",
      "list",
      "url",
      "archived"
    ],
    "relatedArticles": [
      "multi-site-navigation",
      "archiving-deleting",
      "bulk-operations"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "backups",
    "title": "Backup and Recovery",
    "summary": "A nightly job snapshots the SQLite database to object storage, verifies the upload, and prunes old snapshots on a retention schedule. The git history of the site repo is a second, independent backup.",
    "tier": "features",
    "category": "operations",
    "tags": [
      "backup",
      "recovery",
      "sqlite",
      "s3",
      "retention",
      "git"
    ],
    "relatedArticles": [
      "export",
      "settings-api-keys",
      "publishing"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": true
  },
  {
    "slug": "approving-briefs",
    "title": "Reviewing and Approving Briefs",
    "summary": "Read a brief, optionally edit it, and approve to drop it into the pipeline queue. The cron picks up approved briefs every couple of minutes and starts writing.",
    "tier": "features",
    "category": "pipeline",
    "tags": [
      "briefs",
      "approve",
      "reject",
      "reopen",
      "queue",
      "lifecycle"
    ],
    "relatedArticles": [
      "brainstorm",
      "pipeline",
      "brief-lifecycle"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "brainstorm",
    "title": "Running a Brainstorm",
    "summary": "Type a topic, optionally lean on AI suggestion chips, and Claude returns three to five article briefs in under a minute. Approve the ones you like to enter the pipeline.",
    "tier": "features",
    "category": "pipeline",
    "tags": [
      "brainstorm",
      "briefs",
      "topics",
      "suggestions",
      "claude",
      "chips"
    ],
    "relatedArticles": [
      "approving-briefs",
      "pipeline",
      "first-article-end-to-end"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "canceling-pipeline",
    "title": "Canceling and Force-Completing",
    "summary": "Cancel a run to discard it, or force-complete to push the writer's current output straight to drafts without finishing review. Force complete is admin-only and flags the result.",
    "tier": "features",
    "category": "pipeline",
    "tags": [
      "cancel",
      "force-complete",
      "pipeline",
      "admin",
      "stuck",
      "runs"
    ],
    "relatedArticles": [
      "pipeline",
      "pipeline-states",
      "troubleshooting"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": true
  },
  {
    "slug": "pipeline",
    "title": "Monitoring the Pipeline",
    "summary": "Watch approved briefs move through write, review, and revise. Each run card shows status, iteration count, and review score, and polls itself until it reaches a terminal state.",
    "tier": "features",
    "category": "pipeline",
    "tags": [
      "pipeline",
      "runs",
      "status",
      "iteration",
      "review-score",
      "monitor"
    ],
    "relatedArticles": [
      "approving-briefs",
      "canceling-pipeline",
      "pipeline-states"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "ai-prompt-generation",
    "title": "AI-Generated Prompts",
    "summary": "Step 6 of the site wizard fires four generators in parallel to turn your site context into customized writer, reviewer, brainstorm, and illustrator personas — each with token counts and an auto-test.",
    "tier": "features",
    "category": "prompts",
    "tags": [
      "prompts",
      "generator",
      "ai",
      "wizard",
      "site-context",
      "auto-test"
    ],
    "relatedArticles": [
      "prompts-overview",
      "prompt-testing",
      "site-creation-wizard"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "prompt-syncing",
    "title": "Syncing from Templates",
    "summary": "When a template improves after a site was created, Sync from template pulls the latest body into the site's persona as a reviewable diff — template edits never auto-propagate.",
    "tier": "features",
    "category": "prompts",
    "tags": [
      "prompts",
      "sync",
      "template",
      "diff",
      "version",
      "drift"
    ],
    "relatedArticles": [
      "prompts-overview",
      "prompt-testing",
      "ai-prompt-generation"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "prompt-testing",
    "title": "Testing Your Prompts",
    "summary": "The Test panel previews the exact user message the backend will send alongside the system prompt, runs it against sample input, and shows the raw output so you can validate a persona before it ships.",
    "tier": "features",
    "category": "prompts",
    "tags": [
      "prompts",
      "test",
      "preview",
      "user-message",
      "output",
      "validate"
    ],
    "relatedArticles": [
      "prompts-overview",
      "ai-prompt-generation",
      "prompt-syncing"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "prompts-overview",
    "title": "Understanding Prompts",
    "summary": "Every pipeline call assembles a prompt from three parts — the editable persona body, a hardcoded protocol suffix, and (for the writer) an auto-generated shorthand reference. Templates seed new sites; per-site edits stay local.",
    "tier": "features",
    "category": "prompts",
    "tags": [
      "prompts",
      "persona",
      "template",
      "protocol",
      "assembly",
      "pipeline"
    ],
    "relatedArticles": [
      "ai-prompt-generation",
      "prompt-testing",
      "prompt-syncing"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "archiving-deleting",
    "title": "Archiving and Deleting Content",
    "summary": "Archive hides a draft or article from the active list and starts a 30-day clock; after that an admin can permanently delete it with a slug-typed confirmation.",
    "tier": "features",
    "category": "publishing",
    "tags": [
      "archive",
      "delete",
      "hard-delete",
      "retention",
      "admin",
      "trash"
    ],
    "relatedArticles": [
      "unpublishing",
      "bulk-operations",
      "article-lifecycle"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": true
  },
  {
    "slug": "bulk-operations",
    "title": "Bulk Operations",
    "summary": "Select multiple rows with checkboxes to pop a floating action bar, then archive drafts and briefs or delete alerts in one move. Export to CSV from the page header.",
    "tier": "features",
    "category": "publishing",
    "tags": [
      "bulk",
      "multi-select",
      "archive",
      "export",
      "csv",
      "action-bar"
    ],
    "relatedArticles": [
      "archiving-deleting",
      "search-filter-sort",
      "unpublishing"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "publishing",
    "title": "Publishing an Article",
    "summary": "Publish converts your draft to MDX, generates illustrations, applies interlinks, and pushes to the site repo — Cloudflare Pages deploys automatically. Watch the four-step progress toast.",
    "tier": "features",
    "category": "publishing",
    "tags": [
      "publish",
      "deploy",
      "cloudflare",
      "mdx",
      "progress",
      "git"
    ],
    "relatedArticles": [
      "unpublishing",
      "archiving-deleting",
      "preview-modal"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "unpublishing",
    "title": "Unpublishing and Republishing",
    "summary": "Unpublish removes a live article's MDX from the site repo while keeping the row. It is reversible — republish from the same draft when you're ready.",
    "tier": "features",
    "category": "publishing",
    "tags": [
      "unpublish",
      "republish",
      "reversible",
      "articles",
      "live"
    ],
    "relatedArticles": [
      "publishing",
      "archiving-deleting",
      "bulk-operations"
    ],
    "lastVerified": "2026-05-27",
    "adminOnly": false
  },
  {
    "slug": "settings-api-keys",
    "title": "API Key Configuration",
    "summary": "Settings groups managed credentials by category. Enter a key, test the connection, and save — changes apply within 10 seconds. Critical keys require typed confirmation and reveal for only five seconds.",
    "tier": "features",
    "category": "settings",
    "tags": [
      "settings",
      "api-keys",
      "secrets",
      "integrations",
      "anthropic",
      "cloudflare"
    ],
    "relatedArticles": [
      "domain-setup",
      "backups",
      "analytics"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": true
  },
  {
    "slug": "site-creation-wizard",
    "title": "The Site Creation Wizard",
    "summary": "A seven-step guided flow that turns a one-line description into a fully scaffolded site — AI-bootstrapped context, theme, component packs, generated prompts, and suggested authority sources.",
    "tier": "features",
    "category": "sites",
    "tags": [
      "wizard",
      "site-creation",
      "bootstrap",
      "scaffold",
      "packs",
      "prompts"
    ],
    "relatedArticles": [
      "site-management",
      "ai-prompt-generation",
      "authority-sources"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "site-hub",
    "title": "The Site Hub Dashboard",
    "summary": "The Overview tab is the site's dashboard — a health strip, Search Console metric cards, recent pipeline and publish activity, and quick-action chips, with settings widgets below.",
    "tier": "features",
    "category": "sites",
    "tags": [
      "site-hub",
      "overview",
      "dashboard",
      "health",
      "metrics",
      "quick-actions"
    ],
    "relatedArticles": [
      "site-management",
      "analytics",
      "multi-site-navigation"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "site-management",
    "title": "Managing Your Sites",
    "summary": "Every site lives behind its own slug and hub. The Sites lobby lists them all; each hub gathers Overview, Domains, Theme, Components, Assets, Prompts, and Articles into one place.",
    "tier": "features",
    "category": "sites",
    "tags": [
      "sites",
      "hub",
      "multi-site",
      "lobby",
      "overview",
      "slug"
    ],
    "relatedArticles": [
      "site-hub",
      "multi-site-navigation",
      "site-creation-wizard"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "theme-customization",
    "title": "Customizing Your Theme",
    "summary": "Start from one of four presets, then tune sixteen color tokens and three font families. A live preview reflects every change, and Re-illustrate all repaints existing SVGs to match.",
    "tier": "features",
    "category": "theming",
    "tags": [
      "theme",
      "preset",
      "colors",
      "fonts",
      "preview",
      "re-illustrate"
    ],
    "relatedArticles": [
      "site-management",
      "illustrations",
      "site-hub"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "shorthand-syntax",
    "title": "Component Shorthand Syntax",
    "summary": "The full prop-by-prop reference for every bracket shorthand — name, type, whether it is required, and a working example for each component.",
    "tier": "reference",
    "category": "components",
    "tags": [
      "shorthand",
      "components",
      "props",
      "reference",
      "syntax",
      "quickanswer",
      "faq",
      "callout",
      "image"
    ],
    "relatedArticles": [
      "component-reference",
      "shorthand-components",
      "unified-editor",
      "images"
    ],
    "lastVerified": "2026-07-01",
    "adminOnly": false
  },
  {
    "slug": "site-context-schema",
    "title": "Site Context Fields",
    "summary": "Every field in a site's structured context blob, what it controls downstream, and an example value.",
    "tier": "reference",
    "category": "configuration",
    "tags": [
      "site-context",
      "schema",
      "fields",
      "audience",
      "domain",
      "voice",
      "configuration"
    ],
    "relatedArticles": [
      "site-creation-wizard",
      "prompt-placeholders",
      "prompts-overview"
    ],
    "lastVerified": "2026-07-01",
    "adminOnly": false
  },
  {
    "slug": "annotation-lifecycle",
    "title": "Annotation Lifecycle",
    "summary": "How an annotation moves from a note you leave on a draft, through a revision, to a resolved and finally cleared state.",
    "tier": "reference",
    "category": "lifecycle",
    "tags": [
      "annotation",
      "lifecycle",
      "states",
      "revise",
      "resolve",
      "redline",
      "review"
    ],
    "relatedArticles": [
      "annotations",
      "revisions",
      "article-lifecycle"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "article-lifecycle",
    "title": "Article Lifecycle",
    "summary": "How an article moves from draft to live and through unpublishing, archiving, and permanent deletion.",
    "tier": "reference",
    "category": "lifecycle",
    "tags": [
      "article",
      "lifecycle",
      "states",
      "publish",
      "archive",
      "delete",
      "status"
    ],
    "relatedArticles": [
      "publishing",
      "unpublishing",
      "archiving-deleting"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "brief-lifecycle",
    "title": "Brief Lifecycle",
    "summary": "The states a brief moves through from a brainstorm proposal to an approved, in-pipeline, and ultimately published topic — plus the reject and archive branches.",
    "tier": "reference",
    "category": "lifecycle",
    "tags": [
      "brief",
      "lifecycle",
      "states",
      "brainstorm",
      "approve",
      "reject",
      "archive"
    ],
    "relatedArticles": [
      "brainstorm",
      "approving-briefs",
      "pipeline-states"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "pipeline-states",
    "title": "Pipeline Run States",
    "summary": "The states a pipeline run moves through from the moment a brief is approved to the moment it lands as a draft, fails, or is cancelled.",
    "tier": "reference",
    "category": "lifecycle",
    "tags": [
      "pipeline",
      "states",
      "lifecycle",
      "status",
      "writing",
      "reviewing",
      "draft"
    ],
    "relatedArticles": [
      "understanding-the-pipeline",
      "canceling-pipeline",
      "article-lifecycle"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "prompt-placeholders",
    "title": "Prompt Placeholder Reference",
    "summary": "The substitution tokens you can use in a persona prompt, where each one pulls its value from in the site context, and which personas expect it.",
    "tier": "reference",
    "category": "prompts",
    "tags": [
      "prompts",
      "placeholders",
      "tokens",
      "substitution",
      "personas",
      "site-context"
    ],
    "relatedArticles": [
      "prompts-overview",
      "site-context-schema",
      "ai-prompt-generation"
    ],
    "lastVerified": "2026-07-01",
    "adminOnly": false
  },
  {
    "slug": "api-key-permissions",
    "title": "API Key Permissions",
    "summary": "Every external credential the platform uses, what it powers, the access it needs, and where to create it.",
    "tier": "reference",
    "category": "settings",
    "tags": [
      "api-keys",
      "credentials",
      "permissions",
      "anthropic",
      "cloudflare",
      "google",
      "github",
      "secrets"
    ],
    "relatedArticles": [
      "settings-api-keys",
      "error-codes",
      "backups"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": true
  },
  {
    "slug": "keyboard-shortcuts-full",
    "title": "Complete Keyboard Shortcuts",
    "summary": "Every keyboard shortcut in the dashboard, grouped by where it works — global navigation, the editor, the preview modal, and multi-select lists.",
    "tier": "reference",
    "category": "shortcuts",
    "tags": [
      "shortcuts",
      "keyboard",
      "keys",
      "hotkeys",
      "reference",
      "productivity"
    ],
    "relatedArticles": [
      "keyboard-shortcuts-quick",
      "dashboard-layout",
      "unified-editor"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "theme-variables",
    "title": "Theme CSS Variable Reference",
    "summary": "Every theme CSS custom property, what it controls, and its default value in each of the four built-in presets.",
    "tier": "reference",
    "category": "theming",
    "tags": [
      "theme",
      "css",
      "variables",
      "palette",
      "presets",
      "colors",
      "typography"
    ],
    "relatedArticles": [
      "theme-customization",
      "site-hub",
      "site-context-schema"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "error-codes",
    "title": "Error Codes and Messages",
    "summary": "The error messages, status codes, and warning flags you are most likely to see, what each one means, and how to clear it.",
    "tier": "reference",
    "category": "troubleshooting",
    "tags": [
      "errors",
      "codes",
      "messages",
      "flags",
      "warnings",
      "troubleshooting",
      "http"
    ],
    "relatedArticles": [
      "troubleshooting",
      "pipeline-states",
      "settings-api-keys"
    ],
    "lastVerified": "2026-07-01",
    "adminOnly": false
  },
  {
    "slug": "troubleshooting",
    "title": "Troubleshooting Guide",
    "summary": "The most common problems operators hit, with a quick diagnosis and fix for each. Expand the one that matches what you are seeing.",
    "tier": "reference",
    "category": "troubleshooting",
    "tags": [
      "troubleshooting",
      "problems",
      "fixes",
      "errors",
      "help",
      "diagnosis"
    ],
    "relatedArticles": [
      "error-codes",
      "pipeline-states",
      "settings-api-keys"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "component-system",
    "title": "How Components Work",
    "summary": "You author with bracket shorthand; the converter maps it to MDX tags; the shared @aeo/ui library renders them to HTML. The component library is fixed, the content varies, and one registry keeps every surface in sync.",
    "tier": "concepts",
    "category": "infrastructure",
    "tags": [
      "components",
      "shorthand",
      "mdx",
      "aeo-ui",
      "packs",
      "registry",
      "mental-model"
    ],
    "relatedArticles": [
      "shorthand-components",
      "component-packs",
      "shorthand-syntax"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "publishing-infrastructure",
    "title": "How Publishing Works",
    "summary": "Publishing converts your draft to MDX, commits it to git, and lets Cloudflare Pages deploy it to the edge. The git log is the audit trail; the dashboard never touches Cloudflare directly.",
    "tier": "concepts",
    "category": "infrastructure",
    "tags": [
      "publishing",
      "git",
      "cloudflare",
      "mdx",
      "deploy",
      "converter",
      "cdn",
      "mental-model"
    ],
    "relatedArticles": [
      "publishing",
      "interlinks",
      "illustrations"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "theming-system",
    "title": "How Theming Works",
    "summary": "A theme is a bundle of values that becomes CSS variables, which Tailwind utilities read, which components use. Change the values and the whole site re-skins with no code edits.",
    "tier": "concepts",
    "category": "infrastructure",
    "tags": [
      "theming",
      "css-variables",
      "tailwind",
      "presets",
      "design-tokens",
      "mental-model"
    ],
    "relatedArticles": [
      "theme-customization",
      "theme-variables",
      "component-system"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "aeo-explained",
    "title": "What is AEO?",
    "summary": "Answer Engine Optimization is writing content that AI answer engines quote directly. This is the strategy the whole platform is built to execute.",
    "tier": "concepts",
    "category": "strategy",
    "tags": [
      "aeo",
      "answer-engine",
      "seo",
      "strategy",
      "citations",
      "mental-model"
    ],
    "relatedArticles": [
      "platform-overview",
      "understanding-the-pipeline",
      "ai-pipeline-mental-model"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "ai-pipeline-mental-model",
    "title": "How the AI Pipeline Thinks",
    "summary": "The pipeline is four Claude personas with different jobs, not one model doing everything. Knowing each persona's job tells you what to expect and where to intervene.",
    "tier": "concepts",
    "category": "strategy",
    "tags": [
      "pipeline",
      "personas",
      "brainstorm",
      "writer",
      "reviewer",
      "illustrator",
      "mental-model"
    ],
    "relatedArticles": [
      "understanding-the-pipeline",
      "prompt-architecture",
      "aeo-explained"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  },
  {
    "slug": "prompt-architecture",
    "title": "Prompt Architecture Deep Dive",
    "summary": "Every prompt Claude sees is assembled from layers — a compiled template, the site's editable base, context substitution, and a hardcoded protocol suffix. Knowing the layers tells you what you can safely edit.",
    "tier": "concepts",
    "category": "strategy",
    "tags": [
      "prompts",
      "architecture",
      "personas",
      "protocol",
      "substitution",
      "templates",
      "mental-model"
    ],
    "relatedArticles": [
      "prompts-overview",
      "prompt-placeholders",
      "ai-pipeline-mental-model"
    ],
    "lastVerified": "2026-05-28",
    "adminOnly": false
  }
];
